import axios from "axios";
export default {
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async createOnlyPartner( _, data){
      return await axios.post('/partners/only', data)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async createPartner( _, formData){
      return await axios.post('/partners', formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async loadPartner( _, params){
      return await axios.get('/partners', { params })
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async loadPartnerDetail( _, id){
      return await axios.get(`/partners/${id}`)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async updatePartner( _, {id, data}){
      return await axios.put(`/partners/${id}`, data)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async updatePartnerInfo( _, data){
      return await axios.put(`/partners/owner`, data)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async updateOnlyPartner( _, {id, data}){
      return await axios.put(`/partners/${id}/only`, data)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async loadPartnerOwner(){
      return await axios.get(`/partners/owner`)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
  },
};
